import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: theme.palette.mode === 'light' ? 'background.paper' : 'background.default',
        p: 3,
        mt: 'auto',  // This pushes the footer to the bottom
      }}
    >
      <Typography 
        variant="body2" 
        align="center"
        sx={{
          color: theme.palette.text.secondary,
        }}
      >
        © {new Date().getFullYear()} YYDS. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
